
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shell",
      function () {
        return require("private-next-pages/shell.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shell"])
      });
    }
  